import { OnboardingShell } from "./OnboardingShell";

export function OnboardingSchedulePage() {
  return (
    <OnboardingShell
      step={4}
      title="Lịch làm việc"
      description="Cấu hình khung giờ làm việc hàng tuần cho từng bác sĩ."
      ctaTo="/settings/schedules"
      ctaLabel="Mở lịch làm việc"
      backTo="/onboarding/doctors"
      nextTo="/onboarding/import"
    >
      <p className="text-sm text-muted-foreground">
        Khung giờ làm việc quyết định các khung giờ trống mà bệnh nhân có thể đặt.
      </p>
    </OnboardingShell>
  );
}
